import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore()
        }
      })
    }, {
      rootMargin: "200px",
    })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  loadMore() {
    const button = this.element.querySelector('button') || this.element.querySelector('form')
    if (button) {
      button.requestSubmit ? button.requestSubmit() : button.click()
    }
  }
}
